/* @flow */

import React from 'react';
import glamorous from 'glamorous';

type Props = {
  items: Array<*>,
  title: string,
};

const Item = glamorous.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  fontSize: theme.fontSize.xsmall,
  paddingTop: theme.spacing.xsmall,
  paddingBottom: theme.spacing.xsmall,
  '&:not(:last-child)': {
    borderBottom: '1px solid rgba(100, 100, 100, 0.25)',
  },
}));

const Key = glamorous.span({
  flexBasis: 0,
  flexGrow: 1,
  flexShrink: 1,
});

const Title = glamorous.div(({ theme }) => ({
  fontSize: theme.fontSize.xsmall,
  textTransform: 'uppercase',
  borderBottom: '1px solid rgba(100, 100, 100, 0.5)',
  fontWeight: theme.fontWeight.demiBold,
  marginBottom: theme.spacing.small,
}));

function ScoringContentRow({ items, title }: Props) {
  return (
    <div>
      <Title>{title}</Title>
      <div>
        {items.map((score, i) => (
          <Item
            key={i} // eslint-disable-line react/no-array-index-key
          >
            <Key>{score.name}</Key>
            <span>{score.value}</span>
          </Item>
        ))}
      </div>
    </div>
  );
}

export default ScoringContentRow;
